import type {
  INotificationChannel} from 'src/interfaces/pushNotification';
import {
  NotificationChannelId,
  NotificationImportance,
  NotificationVisibility,
} from 'src/interfaces/pushNotification'

export const DEFAULT_NOTIFICATION_CHANNELS: Record<
  NotificationChannelId,
  INotificationChannel
> = {
  [NotificationChannelId.GENERAL]: {
    id: NotificationChannelId.GENERAL,
    name: 'General Notifications',
    description: 'General app notifications',
    importance: NotificationImportance.DEFAULT,
    visibility: NotificationVisibility.PRIVATE,
  },

  [NotificationChannelId.CALENDAR]: {
    id: NotificationChannelId.CALENDAR,
    name: 'Calendar Events',
    description: 'Calendar event reminders and updates',
    importance: NotificationImportance.HIGH,
    visibility: NotificationVisibility.PRIVATE,
    sound: 'default',
    vibration: true,
  },

  [NotificationChannelId.MESSAGES]: {
    id: NotificationChannelId.MESSAGES,
    name: 'Messages',
    description: 'New messages and communications',
    importance: NotificationImportance.HIGH,
    visibility: NotificationVisibility.PRIVATE,
    sound: 'default',
    vibration: true,
  },

  [NotificationChannelId.ALERTS]: {
    id: NotificationChannelId.ALERTS,
    name: 'Important Alerts',
    description:
      'High priority notifications such as behavior incidents, payment failures, and expiring items',
    importance: NotificationImportance.MAX,
    visibility: NotificationVisibility.PUBLIC,
    sound: 'default',
    vibration: true,
    lights: true,
  },

  [NotificationChannelId.CRITICAL_ALERTS]: {
    id: NotificationChannelId.CRITICAL_ALERTS,
    name: 'Critical Alerts',
    description:
      'STAFF ONLY: Critical notifications with a distinct alert sound (e.g. overdue medications)',
    importance: NotificationImportance.MAX,
    visibility: NotificationVisibility.PUBLIC,
    sound: 'critical_alert',
    vibration: true,
    lights: true,
  },

  [NotificationChannelId.URGENT_MESSAGES]: {
    id: NotificationChannelId.URGENT_MESSAGES,
    name: 'Urgent Messages',
    description:
      'STAFF ONLY: Notifications for messages flagged as urgent, with a distinct alert sound',
    importance: NotificationImportance.MAX,
    visibility: NotificationVisibility.PUBLIC,
    sound: 'urgent_message',
    vibration: true,
    lights: true,
  },
}

export function getDefaultChannels(): INotificationChannel[] {
  return Object.values(DEFAULT_NOTIFICATION_CHANNELS)
}
